import React, {
    useState,
    useContext,
    useMemo,
    useEffect,
    useCallback,
} from 'react'
import { useForm } from 'react-hook-form'
import withConfig from '../../../../wrappers/withConfig'

import { FacilityAssignmentMITContext } from './DataContext'
import TableContent from '../../../../elem/table/ssr/TableContent'
import { DataContext } from '../../DataContext'
import NoDataComponent from '../../../../elem/table/ssr/NoDataComponent'
import parseColumns from '../../../../../utils/table/parseColumns'
import deepEqual from 'deep-equal'
import clickSelection from '../../../../../utils/table/clickSelection'

export default withConfig(({ config }) => {
    const {
        setFormMethods,
        setFormDirty,
        setSubmissionState,
        submissionState,
        viewOnly,
        activePanel,
    } = useContext(DataContext)
    const { FACILITY_TITLE, LINK_COLUMN, ID_COLUMN } = config
    const [data, setData] = useState([])
    const {
        assignedFacilityData,
        params,
        setParams,
        loadingAssignedFacilities,
        facilityAccessor,
        projectFacilityListConfig,
        highlightedAssignedFacilities,
        setHighlightedAssignedFacilities,
    } = useContext(FacilityAssignmentMITContext)
    // const { pageSize } = assignedFacilityMetadata
    // const adjustedPageCount = (count / pageSize) % 1 === 0 ? pageCount - 1 : pageCount
    const defaultValues = useMemo(
        () => (assignedFacilityData ? assignedFacilityData : null),
        [assignedFacilityData]
    )

    const formConfig = defaultValues
        ? { mode: 'onChange', defaultValues }
        : { mode: 'onChange' }
    const formMethods = useForm(formConfig)
    const { handleSubmit } = formMethods

    const dirty = useMemo(() => {
        const existingData =
            submissionState && submissionState[facilityAccessor]
                ? submissionState[facilityAccessor]
                : []
        const isDirty = !deepEqual(
            existingData.map(x => x['FacilityId']).sort(),
            assignedFacilityData.map(x => x[ID_COLUMN]).sort()
        )
        return isDirty
    }, [submissionState, assignedFacilityData])

    useEffect(() => {        
        if(activePanel === 'Sampling Point Assignments') {
            formMethods.reset(defaultValues)
            setFormMethods(formMethods)
        }
    }, [defaultValues])

    useEffect(() => {
        setData(assignedFacilityData)
    }, [assignedFacilityData])

    useEffect(() => {
        if (!loadingAssignedFacilities) 
            setFormDirty(dirty)
    }, [dirty, loadingAssignedFacilities])

    const count = useMemo(() => assignedFacilityData.length, [assignedFacilityData])

    const columns = useMemo(() =>
        parseColumns(
            assignedFacilityData,
            projectFacilityListConfig,
            LINK_COLUMN,
            ID_COLUMN
        )
    )

    const selectedItems = useMemo(
        () => highlightedAssignedFacilities.map(x => x[ID_COLUMN]),
        [highlightedAssignedFacilities, ID_COLUMN]
    )

    const [lastSelection, setLastSelection] = useState(null)

    const onSubmit = useCallback(
        d => {
            setSubmissionState(prevSubmissionState => ({
                ...prevSubmissionState,
                [facilityAccessor]: data,
            }))
        },
        [data]
    )

    const onClick = useCallback(
        (row, isHighlighted, e, page) => {
            clickSelection(
                e,
                row,
                page,
                highlightedAssignedFacilities,
                assignedFacilityData,
                lastSelection,
                ID_COLUMN,
                setHighlightedAssignedFacilities,
                setLastSelection
            )
        },
        [highlightedAssignedFacilities, assignedFacilityData, lastSelection]
    )

    const updateParams = newParams => {
        setParams(newParams, 'assignedMITFacilities')
        setHighlightedAssignedFacilities([])
    }

    return (
        <div
            className={`assignedFacilitiesPositioning ${
                viewOnly ? 'fullWidthPositioning' : ''
            }`}
        >
            <div className="assignedFacilitiesWrapper">
                <div className="has-text-centered is-size-5 has-text-weight-semibold">
                    {`Assigned ${FACILITY_TITLE}s`}
                </div>
                <form
                    id="assigned-facilities-mit"
                    className="form columns is-multiline"
                    onSubmit={handleSubmit(() => onSubmit())}
                >
                    {count === 0 ? (
                        <div className="column is-12 has-text-centered">
                            <NoDataComponent
                                filterExpanded={false}
                                toggleFilter={() => {}}
                                subject={
                                    'No sampling points are assigned to this MIT report yet.'
                                }
                                message={''}
                            />
                        </div>
                    ) : (
                        <TableContent
                            name="assignedMITFacilities"
                            {...{
                                columns,
                                loading: loadingAssignedFacilities,
                                params,
                                onClick,
                                setParams: updateParams,
                                resultsCount: assignedFacilityData.length,
                                // pageCount: adjustedPageCount,
                                data: assignedFacilityData,
                                filterExpanded: false,
                                filterFields: projectFacilityListConfig,
                                showAppliedFilterString: false,
                                extraClass: `facilityAssignmentTable`,
                                selectedItems: selectedItems,
                                selectedItemColumn: ID_COLUMN,
                                manualPagination: false,
                            }}
                        />
                    )}
                </form>
            </div>
        </div>
    )
})
